import { useCallback, useEffect, useRef, useState } from "react";
import { ensureCatalogAuth } from "../../../services/backend/authService";
import logger from "../../../shared/utils/logger";

const defaultTransform = (response) => {
  if (Array.isArray(response)) return response;
  if (response && Array.isArray(response.usuarios)) return response.usuarios;
  if (response && Array.isArray(response.rows)) return response.rows;
  return [];
};

const useAdminFetch = (fetcher, options = {}) => {
  const { deps = [], transform = defaultTransform, onError } = options;
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const depsRef = useRef(deps);
  depsRef.current = deps;

  const reload = useCallback(async () => {
    setLoading(true);
    try {
      await ensureCatalogAuth();
      const response = await fetcher();
      setRows(transform(response) ?? []);
    } catch (err) {
      logger.error("Error al cargar datos admin:", err);
      setRows([]);
      if (typeof onError === "function") onError(err);
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, depsRef.current);

  useEffect(() => {
    reload();
  }, [reload]);

  return { rows, loading, reload };
};

export default useAdminFetch;